'use client';

import { Box, Collapsible, Container, Flex, Stack } from '@chakra-ui/react';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa6';

import type { Category } from '@lib/types/directus/directusSchema';
import { LinkButton } from '@ui/link-button';

interface Props {
  categories: Category[];
}

export default function CategoriesTabs({ categories }: Props) {
  const pathname = usePathname();
  const [isTabMenuOpen, setIsTabMenuOpen] = useState(false);

  return (
    <>
      <Container
        maxW="7xl"
        py="3"
        my="3"
        display={{
          base: 'none',
          md: 'block',
        }}
        zIndex="1"
        bg="cream"
      >
        <Box>
          <Flex gap={4} flexWrap="wrap" role="navigation" aria-label="Navigation entre les catégories de guides">
            <LinkButton
              href="/guide-mutuelles"
              bg={pathname.match(/^\/guide-mutuelles(\/\d+)?$/) ? 'primary' : 'gray.200'}
              color={pathname.match(/^\/guide-mutuelles(\/\d+)?$/) ? 'white' : 'initial'}
              borderRadius="full"
              height={10}
              fontSize="md"
              fontWeight="initial"
              justifyContent="start"
            >
              Tous
            </LinkButton>
            {categories.map(({ id, name, slug }) => (
              <LinkButton
                key={id}
                href={`/guide-mutuelles/categorie/${slug}`}
                bg={pathname.startsWith(`/guide-mutuelles/categorie/${slug}`) ? 'primary' : 'gray.200'}
                color={pathname.startsWith(`/guide-mutuelles/categorie/${slug}`) ? 'white' : 'initial'}
                borderRadius="full"
                height={10}
                fontSize="md"
                fontWeight="initial"
                justifyContent="start"
              >
                {name}
              </LinkButton>
            ))}
          </Flex>
        </Box>
      </Container>

      <Collapsible.Root
        mb={14}
        borderBottomWidth="1px"
        display={{
          base: 'block',
          md: 'none',
        }}
        bg="white"
        onOpenChange={(evt) => setIsTabMenuOpen(evt.open)}
      >
        <Collapsible.Trigger paddingY="6" width="full">
          <Flex justifyContent="center" alignItems="center" gap="1.5" fontWeight="bold" color="primary.dark">
            {isTabMenuOpen ? <FaCaretUp /> : <FaCaretDown />} Voir les catégories
          </Flex>
        </Collapsible.Trigger>
        <Collapsible.Content>
          <Container maxW="7xl" py={8}>
            <Box>
              <Stack gap={4} role="navigation" aria-label="Navigation entre les catégories de guides">
                <LinkButton
                  href="/guide-mutuelles"
                  bg={pathname.match(/^\/guide-mutuelles(\/\d+)?$/) ? 'primary' : 'cream'}
                  color={pathname.match(/^\/guide-mutuelles(\/\d+)?$/) ? 'white' : 'initial'}
                  borderRadius="full"
                  height={12}
                  fontSize="md"
                  fontWeight="initial"
                  justifyContent="start"
                  borderWidth="1px"
                  borderColor="gray.200"
                >
                  Tous
                </LinkButton>
                {categories.map(({ id, name, slug }) => (
                  <LinkButton
                    key={id}
                    href={`/guide-mutuelles/categorie/${slug}`}
                    bg={pathname.startsWith(`/guide-mutuelles/categorie/${slug}`) ? 'primary' : 'cream'}
                    color={pathname.startsWith(`/guide-mutuelles/categorie/${slug}`) ? 'white' : 'initial'}
                    borderRadius="full"
                    height={12}
                    fontSize="md"
                    fontWeight="initial"
                    justifyContent="start"
                    borderWidth="1px"
                    borderColor="gray.200"
                  >
                    {name}
                  </LinkButton>
                ))}
              </Stack>
            </Box>
          </Container>
        </Collapsible.Content>
      </Collapsible.Root>
    </>
  );
}
